import { SelectedMenu } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';
import deleteLights from 'rangeConfig/pax/behaviors/deleteLights';
import { matchWidth } from 'rangeConfig/shared/filters/selectedMenuProductFilters';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListChangeLights',
  behaviors: {
    productDeleted: [deleteLights]
  },
  content: [
    {
      id: 'lights-selected-menu-inner-lights',
      title: 'storageone.productListInnerLights',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText',
      behaviors: {
        productClicked: [],
        productDropped: []
      },
      productTypes: [ProductType.PLATSA_INNER_LIGHT],
      noThumbs: () => true,
      productFilters: [matchWidth],
      useMLSorting: true
    }
  ]
};

export default selectedMenu;
